/**
 * Workers are app-only (DECISIONS D1): the web carries no worker screens. Anything that points a
 * worker at "the app" goes through here so there is ONE place to change when a real store URL
 * exists.
 *
 * INTERIM (owner decision 5): no store URL exists in the repo yet, so the app link is the apps
 * section of the platform landing page (`PlatformHome`, `#apps`) — a plain `<a>` because it lives
 * outside the city router's `/<city>` basename.
 */
export const WORKER_APP_URL = "/#apps";

/** The in-app explainer route every worker CTA / app-only notification lands on. */
export const JOIN_WORKER_PATH = "/join-worker";

// Deep links the mobile apps own. The web has no route for them, so navigating to one falls
// through to the catch-all and silently dumps the person on the city home.
const APP_ONLY_PREFIXES = ["/headsup/", "/worker/"];

export function isAppOnlyLink(link) {
  return typeof link === "string" && APP_ONLY_PREFIXES.some((p) => link.startsWith(p));
}
